import { Language } from 'contexts/LanguageContext';

export const getCopy = (lang: Language) => ({
    title:
        lang === 'en'
            ? 'A Special Gift from Shakira to a Lucky Fan'
            : 'Un regalo especial de Shakira para un afortunado fan',
    bodyStages:
        lang === 'en'
            ? [
                  //   <>
                  //       A 2022 Lamborghini Urus S with a 4.0-liter twin-turbo V8 engine generating 666 horsepower, it
                  //       accelerates from 0 to 62 miles per hour in just 3.5 seconds and reaches a top speed of 189 miles
                  //       per hour.
                  //   </>,
                  <>Customized by Shakira, it features a matte purple exterior with an electric green interior.</>,
              ]
            : [
                  //   <>
                  //       Un Lamborghini Urus S 2022 con un motor V8 biturbo de 4.0 litros que genera 666 caballos de
                  //       fuerza, acelera de 0 a 100 km/h en solo 3.5 segundos y alcanza una velocidad máxima de 304 km/h.
                  //   </>,
                  <>Personalizado por Shakira, cuenta con un exterior morado mate y un interior verde eléctrico.</>,
              ],
    videoTitle: lang === 'en' ? 'Shakira - Soltera (Official Video)' : 'Shakira - Soltera (Video Oficial)',
});
